import { normalizeLocale } from './locale.js';
const FALLBACK = 'en';
/**
 * Resolves the active locale with priority:
 * 1. session locale
 * 2. query parameter locale
 * 3. saved user preference
 * 4. browser locale
 * 5. English fallback
 */
export function resolveLocale(input) {
    const candidates = [
        input.sessionLocale,
        input.queryLocale,
        input.savedLocale,
        input.browserLocale,
    ];
    for (const candidate of candidates) {
        const normalized = normalizeLocale(candidate);
        if (normalized)
            return normalized;
    }
    return FALLBACK;
}
//# sourceMappingURL=resolver.js.map